
import React from "react";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

interface ContactFormActionsProps {
  isSubmitting: boolean;
  mode: "create" | "edit";
  minimal?: boolean;
}

export function ContactFormActions({ isSubmitting, mode, minimal = false }: ContactFormActionsProps) {
  const navigate = useNavigate();
  
  return (
    <div className={minimal ? "flex justify-end" : "flex items-center justify-end space-x-4"}>
      {!minimal && (
        <Button
          type="button"
          variant="outline"
          onClick={() => navigate("/contacts")}
        >
          Cancel
        </Button>
      )}
      <Button type="submit" disabled={isSubmitting}>
        {isSubmitting
          ? "Saving..."
          : mode === "create"
          ? "Create Contact"
          : "Update Contact"}
      </Button>
    </div>
  );
}
